import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconTShirtStyle0 = cosmosIconCss;

const CosmosIconTShirt$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTShirt extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '724f0ece7526942a8e9f8cb8a29603ec2f87e4b3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd10e94acdfa94f8d0c1726fc1f65b62f62528dca', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'acb3a0632b7692047e01f0f3a626a64f5bff611e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m14.516 6.107 3.76 1.457-.833 2.775-2.805-.797a.5.5 0 0 0-.638.481V15.5H8v-5.477a.5.5 0 0 0-.638-.48l-2.805.797-.832-2.776 3.758-1.456A7.803 7.803 0 0 0 11 6.85a7.803 7.803 0 0 0 3.516-.743Zm-.103-1.605a.591.591 0 0 0-.34.128A5.91 5.91 0 0 1 11 5.35a5.91 5.91 0 0 1-3.073-.72.667.667 0 0 0-.351-.125.712.712 0 0 0-.25.055l-4.905 1.9c-.38.15-.49.35-.38.71l1.331 4.44c.095.3.266.451.517.451a.824.824 0 0 0 .214-.031l2.397-.68v5.15a.495.495 0 0 0 .5.5h8a.495.495 0 0 0 .5-.5v-5.15l2.398.68a.776.776 0 0 0 .221.035c.25 0 .423-.156.51-.455l1.331-4.44c.11-.36 0-.56-.38-.71l-4.905-1.9a.746.746 0 0 0-.26-.058h-.002Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconTShirtStyle0; }
}, [1, "cosmos-icon-t-shirt", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-t-shirt"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-t-shirt":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTShirt$1);
            }
            break;
    } });
}

const CosmosIconTShirt = CosmosIconTShirt$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTShirt, defineCustomElement };
